import * as React from "react";
import { Text, useFieldState, FieldProps, useFieldApi } from "informed";
import * as classNames from 'classnames';
import { inputClasses } from "../validation/ValidationClasses";
import { replaceDotsWithHyphens } from "../../misc/Helpers/StringHelper";

interface TextBox2Props<V, VS> extends FieldProps<V, VS> {
    id?: string;
    field: string;
    inputAddon?: React.ReactNode;
    type?: string;
}

/**
 * HACK:
 * Temporary workaround: applies useEffect on inputs that cause test failures. 
 * Remove once a permanent fix is available with an updated and tested Informed version.
 */
export const TextBox2 = <V, VS>({ id, field, inputAddon, type, ...props }: TextBox2Props<V, VS>) => {
    const fieldApi = useFieldApi(field);
    const fieldState = useFieldState(field);
    const [error, setError] = React.useState<string>();

    const divClasses = classNames({
        "input-group": inputAddon !== undefined,
        "field-block-error": !!error,
        "field-block-valid": !error,
    });

    /**
     * HACK:
     * fieldApi.getError() doesn’t reliably trigger re-renders, and fieldState.error may not always reflect the error.
     * Using both together keeps the error state in sync for now.
     */
    React.useEffect(() => {
        setError(fieldApi.getError());
    }, [fieldState]);

    if (type === 'hidden') {
        return null;
    }
    else {
        return (
            <>
                <div className={divClasses}>
                    <Text<V, VS>
                        id={id}
                        field={field}
                        type={type}
                        data-automationid={replaceDotsWithHyphens(field)}
                        className={inputClasses(error)}
                        {...props}
                    />
                    {inputAddon ? <span className="input-group-addon">{inputAddon}</span> : null}
                </div>
                {error ? <span data-automationid="ValidationError" className="field-validation-error">{error}</span> : null}
            </>
        );
    }

}
